export const BLACKLIST_LIST_PAGE_PATH = '/blacklist/list'
